import authService from './authService';

const BASE = '/api/baiql/scripts';

function authHeaders() {
  const t = authService.getToken && authService.getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function createScript(name, content, userId) {
  const res = await fetch(BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    credentials: 'include',
    body: JSON.stringify({ name, content, userId })
  });
  const ct = res.headers.get('content-type') || '';
  const raw = await res.text();
  const json = ct.includes('application/json') && raw ? JSON.parse(raw) : { success:false, message: raw };
  if (!res.ok) throw new Error(json?.message || raw || `HTTP ${res.status}`);
  return json;
}

export async function listScripts(userId) {
  const url = userId ? `${BASE}?userId=${encodeURIComponent(userId)}` : BASE;
  const res = await fetch(url, { headers: authHeaders(), credentials:'include' });
  if (!res.ok) throw new Error(await res.text() || `HTTP ${res.status}`);
  return await res.json();
}

export async function getScript(id) {
  const res = await fetch(`${BASE}/${id}`, { headers: authHeaders(), credentials:'include' });
  if (!res.ok) throw new Error(await res.text() || `HTTP ${res.status}`);
  return await res.json();
}

export async function updateScript(id, name, content) {
  const res = await fetch(`${BASE}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    credentials: 'include',
    body: JSON.stringify({ name, content })
  });
  const ct = res.headers.get('content-type') || '';
  const raw = await res.text();
  const json = ct.includes('application/json') && raw ? JSON.parse(raw) : { success:false, message: raw };
  if (!res.ok) throw new Error(json?.message || raw || `HTTP ${res.status}`);
  return json;
}

export async function deleteScript(id) {
  const res = await fetch(`${BASE}/${id}`, { method:'DELETE', headers: authHeaders(), credentials:'include' });
  const ct = res.headers.get('content-type') || '';
  const raw = await res.text();
  const json = ct.includes('application/json') && raw ? JSON.parse(raw) : { success:false, message: raw };
  if (!res.ok) throw new Error(json?.message || raw || `HTTP ${res.status}`);
  return json;
}

export async function getScriptMeta(id) {
  const res = await fetch(`${BASE}/${id}/meta`, { headers: authHeaders(), credentials:'include' });
  if (!res.ok) throw new Error(await res.text() || `HTTP ${res.status}`);
  return await res.json();
}

export async function updateScriptMeta(id, meta) {
  const res = await fetch(`${BASE}/${id}/meta`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    credentials: 'include',
    body: JSON.stringify(meta || {})
  });
  const ct = res.headers.get('content-type') || '';
  const raw = await res.text();
  const json = ct.includes('application/json') && raw ? JSON.parse(raw) : { success:false, message: raw };
  if (!res.ok) throw new Error(json?.message || raw || `HTTP ${res.status}`);
  return json;
}


